module.exports = __webpack_public_path__ + "img/807.fc199780.gif";